<template>
	<div>
		<div><h1 hidden=false>{{siteIdF}}</h1> </div>
		<el-table
			:data="tableData"
			
			:row-class-name="tableRowClassName"	size="mini"
			:header-cell-style="{background:'#eee',color:'#606266'}"
		    style="width: 100%">
		   
		   <el-table-column
		     label="ID" width="50px"
		     prop="id">
		   </el-table-column>
		   <el-table-column
		     label="站点" 
		     prop="station_id" :formatter="formatter">
		   </el-table-column>
		   <el-table-column 
		     label="命令" width="250px"
		     prop="orderName">
		   </el-table-column>	
			<el-table-column
			  label="状态"
			  prop="state" >
			</el-table-column>		
			<el-table-column
			  label="执行结果"
			  prop="order_ret" >
			</el-table-column>
			<el-table-column
			  label="创建时间"
			  prop="crt_time" >
			</el-table-column>
			<el-table-column
			  label="更新时间"
			  prop="up_time">
			</el-table-column>
			<el-table-column  label="操作">
			  <template slot-scope="scope">
				  <el-button @click="handleClick(scope.row)" type="text" size="mini">取消</el-button>
				  
			</template>
			</el-table-column>
		 </el-table><br />
		
		 <el-row style="background-color: #eee; text-align: left; ">
		 <el-button type="text" style="margin-left: 10px;" @click="addOrder">新建</el-button>
		 </el-row><br />
		 
		 <el-table
		 	:data="tableDataHis"
		 	
		 	:row-class-name="tableRowClassName"	size="mini"
			:header-cell-style="{background:'#eee',color:'#606266'}"
		     style="width: 100%">
		    
		    <el-table-column
		      label="ID" width="50px"
		      prop="id">
		    </el-table-column>
		    <el-table-column
		      label="站点" 
		      prop="station_id" :formatter="formatter">
		    </el-table-column>
		    <el-table-column width="250px"
		      label="命令"
		      prop="orderName">
		    </el-table-column>	
		 	<el-table-column
		 	  label="状态"
		 	  prop="state" >
		 	</el-table-column>		
		 	<el-table-column
		 	  label="执行结果"
		 	  prop="order_ret">
		 	</el-table-column>
			<el-table-column
			  label="命令参数"
			  prop="order_params">
			</el-table-column>
		 	<el-table-column
		 	  label="创建时间"
		 	  prop="crt_time">
		 	</el-table-column>
		 	<el-table-column
		 	  label="更新时间"
		 	  prop="up_time" >
		 	</el-table-column>
		 	<el-table-column label="操作">
			  <template slot-scope="scope">
			  	  <el-button @click="handleClickD(scope.row)" type="text" size="mini">删除</el-button>
			  	  <el-button @click="handleClickR(scope.row)" type="text" size="mini">重发</el-button>
			  </template>			  
		 	</el-table-column>
		  </el-table>   
		  <el-drawer
		    :title="namelg"
		    :visible.sync="dialogVisible"
		    direction="rtl"
		    
		    size="30%"
		    >
		    
		    <el-form  inline
		  	  ref='updatePos' label-position="left" 
		  	  :model="updatePos" class="comDia" size="mini" >
		  	 	  	  
		  	  <el-form-item label="站点" >
		  	  <el-input autofocus="off" class="updatePosInput-status" size="small" 
			  v-model="updatePos.siteName" :disabled="true"></el-input>
		  	  </el-form-item>
		  	  <el-form-item label="命令" prop="order_id">
		  	  <el-select class="updatePosInput-status" v-model="updatePos.order_id" 
			  ref="selectValue" placeholder="请选择命令" @change="changeOrder">
				   <el-option v-for="(item,index) in orderSelect" :label="item.orderName+'('+item.agreement+')'" :key="item.id" 
				   :value="{value:item.id,label:item.orderName}" >
				   </el-option>						   
		  	  </el-select>
		  	  </el-form-item>
		  	  <el-form-item label="最大次数" prop="max_send_times">
		  	  <el-input   autofocus="off" class="updatePosInput-status" 
		  	  size="small" v-model="updatePos.max_send_times"></el-input>					   
		  	  </el-select>
		  	  </el-form-item>
			  <el-form-item label="时间" >
				  <span class="updatePosInput-status">
			     <el-date-picker v-show ="play" type="date" placeholder="起始时间" style="width: 120px;"
				 v-model="updatePos.order_paramsTime"></el-date-picker>-
			    <el-date-picker v-show ="play" type="date" placeholder="结束时间" style="width: 120px;"
				v-model="updatePos.order_paramsTime1"></el-date-picker>
			   </span>
			   </el-form-item>
		  	 <br />
		  	  <el-form-item>
		  	  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
		  	  <el-button size="small" type="primary" @click="doUpdate(updatePos)">确 定</el-button>
		  	  </el-form-item>
		     </el-form>
		    
		  </el-drawer>
		   
	</div>
</template>

<script>
	
	export default {
		name: "RemoteCtr",
		mounted() {
			//debugger
			//this.updata(this.$store.state.siteId);
		},
		data() {
			return {
			  namelg:"新建命令",
			  tableDataHis:[],
			  tableData:[],
			  field:[],
			  play:false,
			  dialogVisible:false,
			  orderNameLabel:null,
			  siteId:0,
			  siteName:0,
			  
			  orderSelect:[],
			  updatePos: {
			  	id:null,
			  	station_id:null,
			  	order_id:null,
			  	order_params:null,
			  	state_id:null,
			  	try_sended_times:null,
			  	max_send_times:null,
			  	order_ret:null,
			  	crt_time:null,
			  	up_time:null,
				siteName:null,
				orderName:null,
				order_paramsTime:null,
				order_paramsTime1:null
			  },
			}
		  },
		computed:{
			siteIdF: {
				get:function(){
					
					//console.log("hachlog:"+this.$store.state.siteId);
					//this.$data.siteId=this.$store.state.siteId;
					this.updata(this.$store.state.siteId);
					
					return this.$store.state.siteId;
				},
				set:function(){
					
					this.$data.siteId=this.$store.state.siteId;
					//this.msg = value; //最后修改了msg    
				}
			 },
		},
		//  filters: {
		//     // 时间格式的转换
		//     Time(value) {
		//       var dateee = new Date(value).toJSON();  
		//       var date = new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
		//       return date
		//     }
		// },
		methods:{
			formatter (row, column) {
			      
			      let newName = this.siteName;
			      return newName
			    },
			changeOrder(data){
				this.updatePos.orderName=data.label;
				if(data.label.indexOf("数据补登")!=-1)
				this.play=true;
				else
				this.play=false;
				debugger;
			},
			addOrder(){
				this.updatePos.id=null;
				this.updatePos.station_id=this.siteId;
				this.updatePos.order_id=null;
				this.updatePos.order_params=null;
				this.updatePos.state_id=1;
				this.updatePos.try_sended_times=0;
				this.updatePos.max_send_times=3;
				this.updatePos.order_ret=null;
				this.updatePos.crt_time=this.formatLongDate(new Date);
				this.updatePos.up_time=null;
				this.updatePos.siteName=this.$store.state.siteName;
				this.updatePos.order_paramsTime=null;
				this.updatePos.order_paramsTime1=null;
				
				this.dialogVisible=true
			},
			
			handleClick(item){
				this.updatePos.id=item.id;
				this.updatePos.station_id=item.station_id;
				this.updatePos.order_id=item.order_id;
				this.updatePos.orderName=item.orderName;
				
				this.updatePos.order_params=item.order_params;
				this.updatePos.state_id=5;
				this.updatePos.try_sended_times=item.try_sended_times;
				this.updatePos.max_send_times=item.max_send_times;
				this.updatePos.order_ret="用户取消";
				this.updatePos.crt_time=this.formatLongDate(new Date);
				this.updatePos.up_time=this.formatLongDate(new Date);
				this.updatePos.siteName=this.$store.state.siteName;
				this.postRequest("/data/real/ctrlOrder",this.updatePos).then(resp => {
				    if (resp) {
				        this.initEmps();
						
						this.dialogVisible=false;
				    }
				})
			},
			handleClickD(item){
				
				this.deleteRequest("/data/real/ctrlOrder?ids="+item.id).then(resp => {
				    if (resp) {
				        this.initEmps();
						
						this.dialogVisible=false;
				    }
				})
			},
			handleClickR(item){
				this.updatePos.id=item.id;
				this.updatePos.station_id=item.station_id;
				this.updatePos.order_id=item.order_id.value;
				this.updatePos.order_params=item.order_params;
				this.updatePos.state_id=1;
				this.updatePos.try_sended_times=item.try_sended_times;
				this.updatePos.max_send_times=item.max_send_times;
				this.updatePos.order_ret=null;
				this.updatePos.crt_time=item.crt_time;
				this.updatePos.up_time=this.formatLongDate(new Date);
				this.updatePos.siteName=this.$store.state.siteName;
				this.updatePos.order_paramsTime=null;
				this.updatePos.order_paramsTime1=null;
				this.postRequest("/data/real/ctrlOrder",this.updatePos).then(resp => {
				    if (resp) {
				        this.initEmps();
						
						this.dialogVisible=false;
				    }
				})
			},
			initEmps(){
				this.getRequest('/data/real/ctrlOrder?siteId='+this.$data.siteId).then(resp => {
					if(resp.error){
						
						this.$data.field=null;
						 this.$data.tableData=null;
						this.$data.tableDataHis=null;
						this.$message({
						  type:'info',//info
						  message: resp.error
						}); 
					}else{
						
						this.$data.orderSelect=resp["Ctrls"]
						 this.$data.tableData=resp["CtrlOrder"];
						 this.$data.tableDataHis=resp["CtrlOrderHis"];
						 //this.play=true;
						 
					}
					
					/* console.log(this.$data.tableData); */
					
				});
				
			},
			reqPostData(){
				
				
				//console.log("endTime:"+this.formData.endTime+"---startTime:"+this.formData.startTime);
				
				this.initEmps();
				
			},
		  onSubmit() {
					  this.reqPostData(); 
			/* console.log(this.form.endTime); */
		  },
			
			formatLongDate (date) {
				let myyear = date.getFullYear();
				let mymonth = date.getMonth() + 1;
				let myweekday = date.getDate();
				let myHour = date.getHours();
				let myMin = date.getMinutes();
				let mySec = date.getSeconds();

				if (mymonth < 10) {
					mymonth = '0' + mymonth;
				}
				if (myweekday < 10) {
					myweekday = '0' + myweekday;
				}
				if (myHour < 10) {
					myHour = '0' + myHour;
				}
				if (myMin < 10) {
					myMin = '0' + myMin;
				}
				if (mySec < 10) {
					mySec = '0' + mySec;
				}
				return (myyear + '' + mymonth + '' + myweekday + '' + myHour + '' + myMin + '' + mySec);
			},
			
			tableRowClassName({row, rowIndex}) {
					if ((rowIndex%2) == 1) {
					  return 'success-row';
					} 
					return '';
			},
			doUpdate(){
				this.$refs.updatePos.validate((valid) => {
					
									
					if (valid) {
						if(this.updatePos.id==null){
							this.$confirm('此操作新建一条记录', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    debugger
								this.updatePos.id=null;
								this.updatePos.order_id=this.updatePos.order_id.value;
								if(this.updatePos.orderName.indexOf("数据补登")!=-1){
								var statT=this.formatLongDate(this.updatePos.order_paramsTime);
								statT=statT.substring(0,statT.length-4);
								var statE=this.formatLongDate(this.updatePos.order_paramsTime1);
								statE=statE.substring(0,statE.length-6)+"23";								
								this.updatePos.order_params=statT+"~"+statE;
								}
								else
									this.updatePos.order_params="00-23"
								console.log( this.updatePos.param);
							    this.postRequest("/data/real/ctrlOrder",this.updatePos).then(resp => {
							        if (resp) {
							            this.initEmps();
										
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消保存',
									
							    });
								//this.dialogVisible=false;
							});
						}else{
							this.$confirm('此操作修改ID=【' + this.updatePos.id + '】的记录?', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
							    this.postRequest("/data/real/ctrlOrder",this.updatePos).then(resp => {
							        if (resp) {
							            this.initEmps();
										
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
								//this.dialogVisible=false;
							    this.$message({
							        type: 'info',
							        message: '已取消修改'
							    });
								
							});
						}
					} else {
						console.log('请输入所有字段！');
						return false;
					}
				})
				
				
			},
			updata(id){
				if(this.$data.siteId!=id){
					this.$data.siteId=id;
					this.$data.siteName=this.$store.state.siteName;
					this.initEmps();
				}
				
			}
		}
	}
</script>

<style>
	.el-table .success-row {
	    background: #f0f9eb;
	  }
	.block{
		margin-top: 10px;
	}
	.updatePosInput-status {
	    width: 200px;
	    margin-right: 10px;
	}
	.comDia{
		font-size: 0;
		align-items: 100px;
		text-align: left;
		margin-left: 50px;
	}
	.comDia label{
		width: 80px;
		color: #99a9bf;
		
	}
</style>
